import { render, staticRenderFns } from "./SolutionShow.vue?vue&type=template&id=aad9f478&scoped=true&"
import script from "./SolutionShow.vue?vue&type=script&lang=ts&"
export * from "./SolutionShow.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionShow.vue?vue&type=style&index=0&id=aad9f478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad9f478",
  null
  
)

export default component.exports